//
//
//
//
//
//
//
//
//
//
//
//
//

import LinkedCompList from "~/components/compilations/LinkedCompList"
import LinkedCompSlider from "~/components/compilations/LinkedCompSlider"
export default {
  components: {
    LinkedCompList,
    LinkedCompSlider
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    bottomTemplate: {
      type: Object,
      required: false
    }
  },
  computed: {
    isSlider () {
      return Boolean(this.bottomTemplate?.xmlId === '1b')
    },
    isList () {
      return Boolean(this.bottomTemplate?.xmlId === '2b')
    }
  }
}
